export default "__VITE_ASSET__POpmNsME__"